import { render, staticRenderFns } from "./AlimentosEdit.vue?vue&type=template&id=a598cdea&"
import script from "./AlimentosEdit.vue?vue&type=script&lang=js&"
export * from "./AlimentosEdit.vue?vue&type=script&lang=js&"
import style0 from "./AlimentosEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports